interface BlockCoverOpt {
  blockRatio: number;
  maskWidth: number;
  maskHeight: number;
}

class BlockCover {
  block: HTMLElement;

  holder: HTMLElement;

  ratio = 1;

  constructor($block: HTMLElement) {
    this.block = $block;
    this.holder = $block.parentNode as HTMLElement;
    this.init();
  }

  init(): void {
    this.resizeHandler();
    this.attachEvents();
  }

  resizeHandler(): void {
    this.getRatio(this.block);
    this.setBlockPosition();
  }

  getRatio($block: HTMLElement): void {
    this.ratio = $block.clientWidth / $block.clientHeight
      || (parseFloat($block.getAttribute('width') ?? '0') ?? 1)
      / (parseFloat($block.getAttribute('height') ?? '0') ?? 1);
  }

  setBlockPosition(): void {
    const styles = BlockCover.getDimensions({
      blockRatio: this.ratio,
      maskWidth: this.holder.clientWidth,
      maskHeight: this.holder.clientHeight,
    });
    this.block.style.cssText = `width:${styles.width}px;`
      + `height:${styles.height}px;`
      + `top:${styles.top}px;`
      + `left:${styles.left}px;`;
  }

  static getDimensions(data: BlockCoverOpt): {
    width: number;
    height: number;
    top: number;
    left: number;
  } {
    const ratio = data.blockRatio;
    let slideWidth = data.maskWidth;
    let slideHeight = slideWidth / ratio;
    if (slideHeight < data.maskHeight) {
      slideHeight = data.maskHeight;
      slideWidth = slideHeight * ratio;
    }
    return {
      width: slideWidth,
      height: slideHeight,
      top: (data.maskHeight - slideHeight) / 2,
      left: (data.maskWidth - slideWidth) / 2,
    };
  }

  attachEvents(): void {
    window.addEventListener('resize', () => {
      this.resizeHandler();
    }, true);
  }
}

export default BlockCover;
